
import Swiper from 'swiper/swiper-bundle.min'
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import 'swiper/swiper-bundle.min.css'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      navLabels: [],
      swiperInstance: null,
      navInstance: null,
      currentSlideIndex: 0,
      spaceBetween: 16,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },
    controlsStyles() {
      const styles = {}

      styles.margin = this.getBreakpointValue(this.blok.controlsMargin)
      styles['-webkit-mask-image'] =
        'linear-gradient(90deg,transparent,#000 4px,#000 calc(100% - 4px),transparent)'
      styles['mask-image'] =
        'linear-gradient(90deg,transparent,#000 4px,#000 calc(100% - 4px),transparent)'
      // styles.padding = '0 32px'
      styles.width = 'calc(100% + 32px*2)'
      styles.marginLeft = 'calc(32px*-1)'
      styles.borderColor = this.blok.borderColor || '#fff'

      return styles
    },
  },
  // watch: {
  //   '$store.state.app.breakpoint'() {
  //     console.log('update')
  //     this.swiperInstance.update()
  //     this.navInstance.update()
  //   },
  // },

  mounted() {
    this.$nextTick(() => {
      this.setData()
      this.initSwipers()
    })
  },
  methods: {
    setData() {
      this.navLabels = this.blok?.navLabels?.split(',').map((x) => {
        if (!x) return []

        const label = x
        const href = x.toLowerCase().replace(' ', '-')

        return {
          href: '#' + href,
          label,
        }
      })

      this.spaceBetween = this.blok.labelSpacing || 16
    },
    initSwipers() {
      this.$gsap.context(() => {
        this.swiperInstance = new Swiper(this.$refs.carousel, {
          // loop: true,
          effect: this.blok.slideEffect,
          creativeEffect: {
            prev: {
              //   shadow: true,
              translate: [0, 0, -400],
              opacity: 0,
            },
            next: {
              translate: ['100%', 0, 0],
            },
          },
          slidesPerView: 'auto',
          grabCursor: true,
          keyboard: true,
          mousewheel: {
            enabled: true,
            eventsTarget: this.$refs.carousel,
            releaseOnEdges: true,
            thresholdDelta: 0.5,
            thresholdTime: 150,
            forceToAxis: true,
            invert: false,
            sensitivity: 0.5,
            modifiers: {
              axis: 'x',
              delta: 0.5,
              factor: 1,
              invert: false,
              pixelRatio: 1,
              velocity: 0.3,
            },
          },
          speed: 800,
          //   autoplay: {
          //     delay: 10000,
          //     disableOnInteraction: false,
          //   },
          // pagination: {
          //   el: this.$refs.pagination,
          //   clickable: true,

          //   // custom pagination bullets
          //   renderBullet: (index, className) => {
          //     return `<button style="color: ${this.blok.textColor}" class="${className} swiper-slide">
          //           <span class='text-base-semibold pointer-events-none'>${this.navLabels?.[index]?.label}</span>
          //       </button>`
          //   },
          // },
          on: {
            realIndexChange: (swiper) => {
              this.changeSlideIndex(swiper.activeIndex)
            },
            // init: (swiper) => {
            //   this.updateNavigationTextColors(swiper)
            // },
          },
        })

        this.navInstance = new Swiper(this.$refs.nav, {
          breakpoints: {
            320: {
              spaceBetween: 16,
            },
            // 768: {
            //   spaceBetween: 40,
            // },
            1024: {
              spaceBetween: this.blok.labelSpacing || 16,
            },
          },
          spaceBetween: 16,
          slidesPerView: 'auto',
          allowTouchMove: false,
          // spaceBetween: 16,
          grabCursor: false,
          keyboard: true,
          // mousewheel: {
          //   enabled: true,
          //   eventsTarget: '.swiper-button-container',
          //   releaseOnEdges: true,
          //   thresholdDelta: 0.5,
          //   thresholdTime: 150,
          //   forceToAxis: true,
          //   invert: false,
          //   sensitivity: 0.5,
          //   modifiers: {
          //     axis: 'x',
          //     delta: 0.5,
          //     factor: 1,
          //     invert: false,
          //     pixelRatio: 1,
          //     velocity: 0.3,
          //   },
          // },
          speed: 800,
          // navigation: {
          //   // navigation(arrows)
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          // on: {
          //   init: (swiper) => {
          //     console.log(swiper)
          //   },
          // },
        })

        this.swiperInstance.on('mousewheel', (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
            event.preventDefault()
            this.swiperInstance.translateTo(
              -this.swiperInstance.translate + event.deltaX * 2,
              0,
              0
            )
          }
        })

        // this.swiperInstance.controller.control = this.navInstance
        // this.navInstance.controller.control = this.swiperInstance
      }, this.$refs.container)
    },

    changeSlideIndex(index) {
      this.swiperInstance.slideTo(index) // Use the slideTo method to navigate to the specified index
      this.navInstance.slideTo(index)
      this.currentSlideIndex = index
    },
  },
}
